import api from '@services/api';

import { DebitNoteRequest, DebitNoteResponse } from '../models/debitNote';
import { PaginationResponse } from '../models/pagination';

/**
 * <p>
 * API endpoints that cover all debit note related CRUD calls
 */
export const debitNoteApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // GET
    DebitNoteResponse: builder.query<PaginationResponse<DebitNoteResponse>, DebitNoteRequest>({
      query: (request) => ({
        url: encodeURI(
          `/school/debit-note/search?searchTerm=${request.searchTerm}&periodDate=${request.periodDate}&page=${request.page}&size=${request.size}`,
        ),
        method: 'GET',
      }),
      providesTags: ['DebitNote'],
    }),
  }),
});

export const { useDebitNoteResponseQuery } = debitNoteApi;
